import React from "react"
import {
  SkillbuilderActivityCard,
  SkillbuilderActivityLike,
} from "../../../modules/session/activity/skillbuilder-activity-card"
import { usePlanLessonLocal } from "./PlanLessonContext"
import { getCheckboxProps } from "./PlanLessonHelpers"
import type { BasePlanningCardProps } from "./PlanLessonTypes"

// Thin wrapper bridging PlanLessonContext to the shared SkillbuilderActivityCard,
// mirroring PlanLessonBmd.tsx.
//
// Preview is deliberately NOT routed through controller.onPreviewActivity: that
// path sends the tutor to a student-app preview URL, and a Skill Builder has no
// such page. The card opens the picker's preview modal itself, so the controller
// never has to learn about Skill Builders.
export const LocalSkillbuilderActivityCard = ({
  isHomework,
  isPlanningSession,
  activity,
  sessionData,
  index,
  enrolment,
}: BasePlanningCardProps) => {
  const controller = usePlanLessonLocal()

  const checkbox = getCheckboxProps({
    controller,
    isPlanningSession,
    sessionData,
    activity,
    enrolment,
  })

  const deleteEnabled =
    controller.sessionStudentData?.session?.fk_tut_key === activity.fk_tut_key

  const sbActivity = activity as unknown as SkillbuilderActivityLike

  return (
      <SkillbuilderActivityCard
        activity={sbActivity}
        index={index}
        isHomework={isHomework}
        isPlanningSession={isPlanningSession}
        checkbox={checkbox}
        showContextMenu={true}
        onRollOver={() => controller.onMoveActivityPopup(activity as any)}
        onCopyToHomework={() =>
          isPlanningSession
            ? controller.onActivityToHomeLesson(
                activity.pk_lesson_activity_key,
                1,
              )
            : controller.onMoveHomeworkActivityPopup(activity as any)
        }
        onCopyToLessonPlan={() =>
          controller.onActivityToHomeLesson(activity.pk_lesson_activity_key, 0)
        }
        onMoveToHomework={() =>
          controller.onActivityToHomework(activity.pk_lesson_activity_key, 1)
        }
        onMoveToLessonPlan={() =>
          controller.onActivityToHomework(activity.pk_lesson_activity_key, 0)
        }
        onDelete={() =>
          controller.onDelectActivityPopup(activity.pk_lesson_activity_key)
        }
        deleteEnabled={deleteEnabled}
        rollOverEnabled={isPlanningSession || !!sessionData?.session}
      />
  )
}

export default LocalSkillbuilderActivityCard
